module.exports = __webpack_public_path__ + "img/logo.b843e387.png";